import React, { useMemo, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import { prepararHtmlAnalisis } from "../../NuevaCotizacion/analisisIAHtml";
import "../../NuevaCotizacion/AnalisisIA.scss";

/** Cuántos hallazgos trae el JSON guardado; null si no se pudo leer */
const contarHallazgos = (json) => {
    try {
        const analisis = JSON.parse(json);
        return Array.isArray(analisis?.hallazgos) ? analisis.hallazgos.length : null;
    } catch {
        return null;
    }
};

/**
 * Botón + diálogo de solo lectura con el análisis IA que se guardó al crear la cotización
 * (HTML_ANALISIS_IA / JSON_ANALISIS_IA). No se muestra si la cotización no tiene análisis.
 */
const DialogAnalisisIA = ({ cotizacion }) => {
    const [visible, setVisible] = useState(false);

    const html = useMemo(
        () => prepararHtmlAnalisis(cotizacion?.htmlAnalisisIA),
        [cotizacion?.htmlAnalisisIA]
    );
    const hallazgos = useMemo(
        () => (cotizacion?.jsonAnalisisIA ? contarHallazgos(cotizacion.jsonAnalisisIA) : null),
        [cotizacion?.jsonAnalisisIA]
    );

    if (!html) return null;

    // Solo es "Todo en orden" si el JSON confirma que no hubo hallazgos
    const hayErrores = hallazgos !== 0;
    const titulo = hallazgos > 0
        ? `Se encontraron ${hallazgos} punto${hallazgos === 1 ? "" : "s"} por revisar`
        : hallazgos === 0 ? "Todo en orden" : "Revisa el reporte de la IA";
    const texto = hallazgos === 0
        ? "La IA no encontró nada que cambiar en la cotización."
        : "Estos son los puntos que la IA marcó al capturar la cotización.";

    return (
        <>
            <Button
                label="Análisis IA"
                icon="pi pi-sparkles"
                severity={hayErrores ? "danger" : "success"}
                className="p-button-outlined p-button-sm"
                onClick={() => setVisible(true)}
                tooltip="Ver el análisis que hizo la IA al crear la cotización"
                tooltipOptions={{ position: "bottom" }}
            />

            <Dialog
                className={`analisis-ia-dialog ${hayErrores ? "con-errores" : "sin-errores"}`}
                header={
                    <span className="analisis-ia-titulo">
                        <i className="pi pi-sparkles" />
                        Análisis de la cotización
                    </span>
                }
                visible={visible}
                onHide={() => setVisible(false)}
                style={{ width: "60rem" }}
                breakpoints={{ "960px": "95vw" }}
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Cerrar" icon="pi pi-times" className="p-button-outlined" onClick={() => setVisible(false)} />
                    </div>
                }
            >
                <div className="analisis-ia-estado">
                    <div className="analisis-ia-estado-icono">
                        <i className={hayErrores ? "pi pi-exclamation-triangle" : "pi pi-check-circle"} />
                    </div>
                    <div>
                        <div className="analisis-ia-estado-titulo">{titulo}</div>
                        <div className="analisis-ia-estado-texto">{texto}</div>
                    </div>
                </div>

                {/* El reporte ya viene en HTML desde la IA; el diseño lo pone .analisis-ia-html */}
                <div className="analisis-ia-html" dangerouslySetInnerHTML={{ __html: html }} />
            </Dialog>
        </>
    );
};

export default DialogAnalisisIA;
